import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { ThemeCustomizer } from './ThemeCustomizer';
import { Card } from '@/components/ui/card';
import { Settings, Palette, Layout } from 'lucide-react';
import { useAdminPreferences } from '@/hooks/useAdminPreferences';

interface DashboardSettingsProps {
  isSpanish?: boolean;
}

export const DashboardSettings: React.FC<DashboardSettingsProps> = ({ isSpanish = false }) => {
  const { preferences, updateTheme, savePreferences } = useAdminPreferences();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Settings className="w-5 h-5 text-muted-foreground" />
        <h2 className="text-2xl font-bold">
          {isSpanish ? 'Configuración del Panel' : 'Dashboard Settings'}
        </h2>
      </div>

      <Tabs defaultValue="theme" className="space-y-4">
        <TabsList className="grid w-full max-w-md grid-cols-2">
          <TabsTrigger value="theme" className="flex items-center gap-2">
            <Palette className="w-4 h-4" />
            {isSpanish ? 'Tema' : 'Theme'}
          </TabsTrigger>
          <TabsTrigger value="layout" className="flex items-center gap-2">
            <Layout className="w-4 h-4" />
            {isSpanish ? 'Diseño' : 'Layout'}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="theme" className="space-y-4">
          <ThemeCustomizer
            preferences={preferences.theme}
            onChange={(theme) => updateTheme(theme)}
            onSave={() => savePreferences(preferences)}
            isSpanish={isSpanish}
          />
        </TabsContent>

        <TabsContent value="layout" className="space-y-4">
          <Card className="p-6">
            <div className="space-y-4">
              <h3 className="text-lg font-semibold">
                {isSpanish ? 'Configuración de Diseño' : 'Layout Configuration'}
              </h3>
              <p className="text-sm text-muted-foreground">
                {isSpanish 
                  ? 'Ve a la página de Resumen para personalizar el diseño de los widgets. Desbloquea el panel para reorganizar y redimensionar los widgets según tus preferencias.'
                  : 'Go to the Summary page to customize the widget layout. Unlock the dashboard to rearrange and resize widgets to your preferences.'}
              </p>
              <div className="bg-muted/50 p-4 rounded-lg">
                <p className="text-sm">
                  <strong>{isSpanish ? 'Consejo:' : 'Tip:'}</strong>{' '}
                  {isSpanish
                    ? 'Tus preferencias de diseño se guardan automáticamente y persistirán entre sesiones.'
                    : 'Your layout preferences are saved automatically and will persist across sessions.'}
                </p>
              </div>
            </div>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
};
